import { IMPERSONATED_SESSION, deleteCookie } from '@portal/common/utility/cookies';

export const getLocalStorageItem = (key: string) => {
    try {
        const item = localStorage.getItem(key);
        return item ? JSON.parse(item) : null;
    } catch {
        return null;
    }
};

export const deleteImpersonation = () => {
    deleteCookie(IMPERSONATED_SESSION);
};

export const removeLocalStorageItem = (key: string) => localStorage.removeItem(key);
